const data = `Miles Robson is currently focusing on SFDC, Rust, and functional JS`

export default data
